module.exports = __webpack_public_path__ + "img/logo-vertical-transparent.5c282ef7.svg";